export default {
  'creativeImage.filter.status.all': '全部状态',
  'creativeImage.filter.status.running': '生成中',
  'creativeImage.filter.status.success': '成功',
  'creativeImage.filter.status.fail': '失败',
  'creativeImage.empty': '暂无图片',
  'creativeImage.loadFailed': '图片列表加载失败',
  'creativeImage.loadingMore': '加载更多…',
  'creativeImage.noMore': '没有更多了',
  'creativeImage.download': '下载',
  'creativeImage.recreate': '重新创作',
  'creativeImage.downloadFailed': '下载失败',
  'creativeImage.delete': '删除',
  'creativeImage.deleteSuccess': '删除成功',
  'creativeImage.deleteFailed': '删除失败，请重试',
  'creativeImage.noPreview': '暂无可预览图片',
  'creativeImage.copyPromptSuccess': '复制成功',
  'creativeImage.copyPromptFailed': '复制失败',
  'creativeImage.meta.refImage': '参考图',
  'creativeImage.meta.refVideo': '参考视频',
  'creativeImage.meta.firstFrame': '首帧图',
  'creativeImage.meta.lastFrame': '尾帧图',
};
